<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Fix Products With No Inventory</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" xs="12" md="7">
                        <v-row class="subtitle-2 text--primary">
                            <v-col cols="12" xs="12" md="6">
                                <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore"
                                    :items="stores" label="Select Shop" item-text="Name" item-value="id"
                                    @change="queryData"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" style="margin-top: -20px">
                                <v-text-field name="checkStockSearch" outlined dense label="Search"
                                    v-model="search"></v-text-field>
                                <!-- start of table -->
                                <v-data-table  :mobile-breakpoint="0" 
                                    :headers="headers" :items="inventory" :search="search" :items-per-page="2000">

                                </v-data-table>
                                <!-- end -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
        </v-card>
    </v-container>
</template>


<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data() {
        return {
            search: null,
            pageItems: 500,
            loader: false,
            editItem: {},
            damagedItem: {},
            transferItem: {},
            store: null,
            queryStore: null,
            stores: [],
            users: [],
            date: null,
            dialog: false,
            damageDialog: false,
            transferDialog: false,
            headers: [
                { text: "Product Id", value: "product_id" },
                { text: "Product Name", value: "name" },
            ],
            fields: {
                Product: "product.Name",
                AvailableQty: "AvailableQty",
            },
            inventory: [],
        };
    },
    methods: {
        queryData() {
            const id = this.queryStore;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", `/no-inventory/${id}`)
                .then((res) => {
                     self.loader = false;
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.inventory = res.ResponseData;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([this.getStores()]);
    },
};
</script>

<style lang="scss" scoped></style>